import { render, staticRenderFns } from "./AnimalNumbersBeef.vue?vue&type=template&id=122e252c&"
import script from "./AnimalNumbersBeef.vue?vue&type=script&lang=js&"
export * from "./AnimalNumbersBeef.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports